import { useCallback } from 'react';

const useTopicPickerUrlSync = ({
  navigate,
  location,
  setListsIds,
  setSearchValue,
  setSelectedTopic,
  searchParamName = 'search',
  topicParamName = 'topic-id',
  mapTopicParamValue = (topic) => topic?.id,
  replace = false,
  keepHash = true,
}) => {
  return useCallback(
    ({ topic, freeSearch }) => {
      const params = new URLSearchParams(location.search);
      let searchToApply = params.toString();

      if (freeSearch) {
        if (setSearchValue) {
          setSearchValue(freeSearch);
        }
        if (setSelectedTopic) {
          setSelectedTopic(null);
        }
        params.delete(topicParamName);
        params.delete(searchParamName);

        const encodedSearchValue = encodeURIComponent(freeSearch);
        const baseSearch = params.toString();
        searchToApply = baseSearch ? `${baseSearch}&${searchParamName}=${encodedSearchValue}` : `${searchParamName}=${encodedSearchValue}`;
      } else if (topic) {
        if (setSelectedTopic) {
          setSelectedTopic(topic);
        }
        if (setListsIds) {
          setListsIds(topic.id);
        }
        params.delete(searchParamName);
        params.delete(topicParamName);
        const topicValue = mapTopicParamValue(topic);
        if (topicValue !== undefined && topicValue !== null) {
          params.set(topicParamName, topicValue);
        }
        searchToApply = params.toString();
      }

      navigate(
        {
          pathname: location.pathname,
          search: searchToApply,
          hash: keepHash ? location.hash : '',
        },
        { replace }
      );
    },
    [
      keepHash,
      location.hash,
      location.pathname,
      location.search,
      mapTopicParamValue,
      navigate,
      replace,
      searchParamName,
      setListsIds,
      setSearchValue,
      setSelectedTopic,
      topicParamName,
    ]
  );
};

export default useTopicPickerUrlSync;
